import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { FuseSharedModule } from '@shared/@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@shared/@fuse/components';
import { FuseModule } from '@shared/@fuse/fuse.module';
import { SharedModule } from '@shared/shared.module';
import { AppComponent } from './app.component';
import { fuseConfig } from '@configs/fuse-config';
import { LayoutModule } from '@layouts/layout.module';

import { CoreModule } from '@core/core.module'; // will be deprecated.
import { EightcapCoreModule } from '@eightcap/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';

@NgModule({
    declarations: [AppComponent],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        CoreModule,
        EightcapCoreModule,
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        HttpClientModule,
        LayoutModule,
        MatButtonModule,
        MatIconModule,
        MatMomentDateModule,
        SharedModule,
        TranslateModule.forRoot()
    ],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
    bootstrap: [AppComponent]
})
export class AppModule {}
